export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7ff0d32af5c7ffd18f93d029d4add1ea7d7f2f01f5&name=fetchTypeahead!'